import BadgeIcon from '@mui/icons-material/Badge';
import gql from 'graphql-tag';
import { GET_LIST, GET_ONE, GET_MANY, GET_MANY_REFERENCE } from 'react-admin';
import { ResourceDefinition, ResourceSections } from 'src/types';
import PassportCreate from './Create';
import PassportEdit from './Edit';

export const PassportResource: ResourceDefinition = {
  name: 'passport',
  section: ResourceSections.PORTAL,
  icon: BadgeIcon,

  create: PassportCreate,
  edit: PassportEdit,

  permissions: {
    create: ['organization:edit'],
    edit: ['organization:edit'],
  },

  extension: {
    operations: {
      [GET_LIST]: { operationName: 'portal_passport' },
      [GET_ONE]: { operationName: 'portal_passport' },
      [GET_MANY]: { operationName: 'portal_passport' },
      [GET_MANY_REFERENCE]: { operationName: 'portal_passport' },
    },
    extraFields: gql`
      {
        authority {
          company_data_api_key
        }
        passport_scope_labels(where: { deleted_at: { _is_null: true } }) {
          passport_id
          display_label
          display_description
          scope_key
        }
        passport_subscription_set_scopes(where: { deleted_at: { _is_null: true } }) {
          passport_id
          scope_key
          subscription_set_id
          passport_scope_label {
            passport_id
            display_label
            scope_key
          }
          participants(where: { deleted_at: { _is_null: true } }) {
            participant_org_id
            passport_id
            subscription_set_id
            participant {
              name
            }
          }
        }
      }
    `,
  },
};
